import * as XLSX from "xlsx";
import { jsPDF } from "jspdf";
import autoTable from "jspdf-autotable";
import { brl, fmtDateTime, fmtQty } from "@/lib/api";

export function fmtCell(v, fmt) {
  if (v === null || v === undefined || v === "") return "";
  if (fmt === "money") return brl(v);
  if (fmt === "pct") return `${Number(v).toLocaleString("pt-BR")}%`;
  if (fmt === "qty") return fmtQty(v);
  if (fmt === "datetime") return fmtDateTime(v);
  return String(v);
}

const rawCell = (v, fmt) => (v === null || v === undefined ? "" : fmt === "datetime" ? fmtDateTime(v) : v);

export function downloadBlob(blob, filename) {
  const a = document.createElement("a");
  a.href = URL.createObjectURL(blob);
  a.download = filename;
  a.click();
  setTimeout(() => URL.revokeObjectURL(a.href), 1000);
}

export function exportCSV(name, report) {
  const head = report.columns.map((c) => c.label);
  const rows = report.rows.map((r) => report.columns.map((c) => fmtCell(r[c.key], c.fmt)));
  const csv = [head, ...rows].map((row) => row.map((v) => `"${String(v).replace(/"/g, '""')}"`).join(";")).join("\n");
  downloadBlob(new Blob(["\ufeff" + csv], { type: "text/csv;charset=utf-8" }), `${name}.csv`);
}

export function exportXLSX(name, title, report) {
  const summary = report.summary.map((s) => [s.label, s.fmt === "text" ? s.value : fmtCell(s.value, s.fmt)]);
  const table = [report.columns.map((c) => c.label), ...report.rows.map((r) => report.columns.map((c) => rawCell(r[c.key], c.fmt)))];
  const ws = XLSX.utils.aoa_to_sheet([[title], [], ...summary, [], ...table]);
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, "Relatório");
  XLSX.writeFile(wb, `${name}.xlsx`);
}

export function exportPDF(name, title, subtitle, report) {
  const doc = new jsPDF({ orientation: report.columns.length > 6 ? "landscape" : "portrait" });
  doc.setFontSize(16);
  doc.text(title, 14, 16);
  doc.setFontSize(9);
  doc.setTextColor(100);
  doc.text(subtitle, 14, 22);
  doc.text(report.summary.map((s) => `${s.label}: ${s.fmt === "text" ? s.value : fmtCell(s.value, s.fmt)}`).join("   ·   "), 14, 28, { maxWidth: doc.internal.pageSize.getWidth() - 28 });
  autoTable(doc, {
    startY: 36,
    head: [report.columns.map((c) => c.label)],
    body: report.rows.map((r) => report.columns.map((c) => fmtCell(r[c.key], c.fmt))),
    styles: { fontSize: 8 },
    headStyles: { fillColor: [37, 99, 235] },
  });
  doc.save(`${name}.pdf`);
}
